export default __webpack_public_path__ + "static/entertainment-35d72f6d0e58fac345071eb1f4748c4f.webp";